<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "../../../../app.config";
import { required } from "vuelidate/lib/validators";
import Swal from "sweetalert2";
import EmployeeAPI from "@/services/employee/employeeAPI";
import CompanyAPI from "@/services/company/companyAPI";
import Table from "@/components/standard/PromotionPrevention/components/PromotionTable";
import { dateFormat } from "@/utils/helpers/format";
import CompanyItemsAPI from "@/services/items/companies_itemsAPI";
import { sendNotification } from "@/utils/helpers/notification";
import ItemAPI from "@/services/items/itemsAPI";
import auditoriaAPI from "../../../services/standards/auditoria/auditoriaAPI";
import newScoresAPI from "../../../services/newScores/newScoresAPI";

/**
 * Basic Tables component
 */
export default {
  page: {
    title: "6.1.2 Auditoria anual del SG SST",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
    Table,
  },
  data() {
    return {
      title: "6.1.2 Auditoria anual del SG SST",

      items: [
        {
          text: "Estándares",
          href: "/forms/estandares",
        },
        {
          text: "6.1.2 Auditoria anual del SG SST",
        },
        {
          text: "Editar",
          active: true,
        },
      ],
      list: [],
      usersList: [],

      item: null,

      itemData: null,
      search: "",

      lista: [],
      loading: true,

      auditoria: {
        deliver_report_date: null,
        deliver_plan_date: null,
        resources: null,
        auditor: null,
        process: null,
        risks_opportunities: null,
        scope: null,
        objetive_program: null,
        completion_date: null,
        start_date: null,
        companies_id: this.$store.getters["company/getCompany"].id || null,
      },

      submitted: false,

      company: this.$store.getters["company/getCompany"] || null,
      companyID: this.$store.getters["company/getCompany"].id || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,
    };
  },
  validations: {
    auditoria: {
      start_date: {
        required,
      },
      completion_date: {
        required,
      },
      objetive_program: {
        required,
      },
      scope: {
        required,
      },
      risks_opportunities: {
        required,
      },
      process: {
        required,
      },
      auditor: {
        required,
      },
      resources: {
        required,
      },
      deliver_plan_date: {
        required,
      },
      deliver_report_date: {
        required,
      },
    },
  },
  methods: {
    getItemData() {
      ItemAPI.getItems(54)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    /**
     * This method indicates whether the company has a classification corresponding to
     * the permit for the item in question.
     * @param {JSON} item The item object.
     */
    allowAccess() {
      try {
        const item = this.itemData;

        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"]
              .company_classification_id || null;

          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    /**
     * This method is used to send notification to SST user and SST company.
     * The sendNotification method import is required.
     * @param {Number} messageID - The message ID that will be associated to notification.
     * @param {Number} itemID - The item ID that will be associated to notification.
     * @param {Boolean} user - The user that will e associated to notification.
     * @return {Boolean} True if the notification is sent, false if not.
     */
    sendNotification(messageID, itemID, user) {
      const company = this.$store.getters["company/getCompany"];
      return sendNotification(
        company.id,
        user ? company.id_diseno_sso : null,
        messageID,
        itemID
      );
    },

    getItems() {
      try {
        CompanyItemsAPI.getStatus(this.companyID, 54)
          .then((response) => {
            this.item = response || null;
          })
          .catch((error) => {
            this.item = null;
            console.log(error);
          });
      } catch (error) {
        this.item = null;
        console.log(error);
      }
    },

    /**
     * This method is used to knows if the user has the permission indicated
     * @param {String} name The name of the permission
     * @param {Array} roles the roles that permitted to access the action
     * @returns {Boolean} true if the user has the permission indicated or false if no
     */
    getRole(name, roles) {
      // Get the user role
      let role = this.$store.state.auth.info.role
        ? this.$store.state.auth.info.role
        : null;

      // If the user is logged
      if (role) {
        // If the roles array is not empty
        if (roles) {
          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false;
        } // Close if the roles arrays is not empty

        // If the roles arrays is empty
        else {
          // Know if the user role is in the roles indicated
          role = role === 1 || role === 2 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8;
        } // Close if the roles arrays is empty

        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions;

        // Know if the user has the permission indicated
        const enabled = permissions.find(
          (permission) => permission.name === name
        );

        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false;
      } // Close if the user is logged

      // If the user is not logged
      else {
        return false;
      } // Close else the user is not logged
    },

    getUsers() {
      CompanyAPI.getCompany(
        this.$store.getters["company/getCompany"].id || null
      )
        .then((response) => {
          EmployeeAPI.getEmployeesPromocion(response.id).then((res) => {
            this.usersList = res.employee;
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getList() {
      auditoriaAPI
        .getAll(this.$store.getters["company/getCompany"].id || null)
        .then((response) => {
          this.lista = response.data.data;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },

    getShow() {
      auditoriaAPI
        .getShow(this.$route.params.id)
        .then((response) => {
          this.auditoria = {
            companies_id: response.data.companies_id,
            start_date: response.data.start_date,
            completion_date: response.data.completion_date,
            objetive_program: response.data.objetive_program,
            scope: response.data.scope,
            risks_opportunities: response.data.risks_opportunities,
            process: response.data.process,
            auditor: response.data.auditor,
            resources: response.data.resources,
            deliver_plan_date: response.data.deliver_plan_date,
            deliver_report_date: response.data.deliver_report_date,
          };
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    goBack() {
      this.$router.go(-1);
    },

    dateConvert(date) {
      return dateFormat(date);
    },

    save() {
      this.submitted = true;
      this.loading = true
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {
        auditoriaAPI
          .update(this.$route.params.id, {
            companies_id: this.auditoria.companies_id,
            start_date: this.auditoria.start_date,
            completion_date: this.auditoria.completion_date,
            objetive_program: this.auditoria.objetive_program,
            scope: this.auditoria.scope,
            risks_opportunities: this.auditoria.risks_opportunities,
            process: this.auditoria.process,
            auditor: this.auditoria.auditor,
            resources: this.auditoria.resources,
            deliver_plan_date: this.auditoria.deliver_plan_date,
            deliver_report_date: this.auditoria.deliver_report_date,
          })
          .then((response) => {
            this.loading = false
            setTimeout(() => {
              const itemChange = {
                companies_id: this.companyID,
                item_id: 54,
                status: 'Pendiente',
              };
              newScoresAPI.calculateScores(itemChange)
                .then((response) => {
                  Swal.fire({
                    title: "¡Éxito!",
                    text: "¡Informacion actualizada con éxito!",
                    type: "success",
                    icon: "success",
                    confirmButtonClass: "btn btn-confirm mt-2",
                  });
                  this.$router.go(-1);
                }, 2000);
            })
              .catch((error) => {
                this.loading = false
                setTimeout(() => {
                  Swal.fire({
                    title: "Error",
                    text: "¡No se ha podido registrar!",
                    icon: "error",
                    type: "error",
                    confirmButtonClass: "btn btn-confirm mt-2",
                  });
                  window.location.reload();
                }, 1000);
                console.log(error);
              });
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
  },
  mounted() {
    this.getList();
    this.getItems();
    this.getItemData();
    this.getUsers();
    this.getShow();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-lg-12">
        <div v-if="!loading">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-12 text-right m-b-0">
                  <div class="btn btn-secondary m-l-5 ml-1" id="back" @click="goBack">
                    <i class="fas fa-arrow-left"></i>
                  </div>
                  <b-tooltip target="back" placement="left"> Volver </b-tooltip>
                </div>
              </div>
              <hr />
              <form class="form-group" @submit.prevent="save">

                <div class="form-row">
                  <b-form-group class="col-md-6 px-2" label="Fecha de realización" label-for="completion_date">
                    <b-form-input :disabled="!allowAccess() || !getRole('Crear')" type="date" id="completion_date"
                      v-model="auditoria.completion_date" :class="{
                        'is-invalid': submitted && $v.auditoria.completion_date.$error,
                      }">
                    </b-form-input>
                    <div v-if="submitted && !$v.auditoria.completion_date.required" class="invalid-feedback">
                      Este campo es requerido.
                    </div>
                  </b-form-group>
                  <b-form-group class="col-md-6 px-2" label="Objetivo del programa de auditoria"
                    label-for="objetive_program">
                    <b-form-input type="text" id="objetive_program" maxlength="100"
                      :disabled="!allowAccess() || !getRole('Crear')" v-model="auditoria.objetive_program" :class="{
                        'is-invalid': submitted && $v.auditoria.objetive_program.$error,
                      }">
                    </b-form-input>
                    <div v-if="submitted && !$v.auditoria.objetive_program.required" class="invalid-feedback">
                      Este campo es requerido.
                    </div>
                  </b-form-group>
                </div>

                <div class="form-row">
                  <b-form-group class="col-md-6 px-2" label="Alcance" label-for="scope">
                    <b-form-input type="text" id="scope" maxlength="100" :disabled="!allowAccess() || !getRole('Crear')"
                      v-model="auditoria.scope" :class="{
                        'is-invalid': submitted && $v.auditoria.scope.$error,
                      }">
                    </b-form-input>
                    <div v-if="submitted && !$v.auditoria.scope.required" class="invalid-feedback">
                      Este campo es requerido.
                    </div>
                  </b-form-group>
                  <b-form-group class="col-md-6 px-2" label="Riesgos y oportunidades" label-for="risks_opportunities">
                    <b-form-input type="text" id="risks_opportunities" maxlength="100"
                      :disabled="!allowAccess() || !getRole('Crear')" v-model="auditoria.risks_opportunities" :class="{
                        'is-invalid': submitted && $v.auditoria.risks_opportunities.$error,
                      }">
                    </b-form-input>
                    <div v-if="submitted && !$v.auditoria.risks_opportunities.required" class="invalid-feedback">
                      Este campo es requerido.
                    </div>
                  </b-form-group>
                </div>

                <div class="form-row">
                  <b-form-group class="col-md-6 px-2" label="Proceso" label-for="process">
                    <b-form-input type="text" id="process" maxlength="100"
                      :disabled="!allowAccess() || !getRole('Crear')" v-model="auditoria.process" :class="{
                        'is-invalid': submitted && $v.auditoria.process.$error,
                      }">
                    </b-form-input>
                    <div v-if="submitted && !$v.auditoria.process.required" class="invalid-feedback">
                      Este campo es requerido.
                    </div>
                  </b-form-group>
                  <b-form-group class="col-md-6 px-2" label="Fecha de Inicio" label-for="start_date">
                    <b-form-input :disabled="!allowAccess() || !getRole('Crear')" type="date" id="start_date"
                      v-model="auditoria.start_date" :class="{
                        'is-invalid': submitted && $v.auditoria.start_date.$error,
                      }">
                    </b-form-input>
                    <div v-if="submitted && !$v.auditoria.start_date.required" class="invalid-feedback">
                      Este campo es requerido.
                    </div>
                  </b-form-group>
                </div>

                <div class="form-row">
                  <b-form-group class="col-md-6 px-2" label="Auditor" label-for="auditor">
                    <b-form-input type="text" id="auditor" maxlength="100"
                      :disabled="!allowAccess() || !getRole('Crear')" v-model="auditoria.auditor" :class="{
                        'is-invalid': submitted && $v.auditoria.auditor.$error,
                      }">
                    </b-form-input>
                    <div v-if="submitted && !$v.auditoria.auditor.required" class="invalid-feedback">
                      Este campo es requerido.
                    </div>
                  </b-form-group>
                  <b-form-group class="col-md-6 px-2" label="Recursos" label-for="resources">
                    <b-form-input type="text" id="resources" maxlength="100"
                      :disabled="!allowAccess() || !getRole('Crear')" v-model="auditoria.resources" :class="{
                        'is-invalid': submitted && $v.auditoria.resources.$error,
                      }">
                    </b-form-input>
                    <div v-if="submitted && !$v.auditoria.resources.required" class="invalid-feedback">
                      Este campo es requerido.
                    </div>
                  </b-form-group>
                </div>

                <div class="form-row">
                  <b-form-group class="col-md-6 px-2" label="Fecha de entrega del plan" label-for="deliver_plan_date">
                    <b-form-input :disabled="!allowAccess() || !getRole('Crear')" type="date" id="deliver_plan_date"
                      v-model="auditoria.deliver_plan_date" :class="{
                        'is-invalid': submitted && $v.auditoria.deliver_plan_date.$error,
                      }">
                    </b-form-input>
                    <div v-if="submitted && !$v.auditoria.deliver_plan_date.required" class="invalid-feedback">
                      Este campo es requerido.
                    </div>
                  </b-form-group>
                  <b-form-group class="col-md-6 px-2" label="Fecha de entrega de informe"
                    label-for="deliver_report_date">
                    <b-form-input :disabled="!allowAccess() || !getRole('Crear')" type="date" id="deliver_report_date"
                      v-model="auditoria.deliver_report_date" :class="{
                        'is-invalid': submitted && $v.auditoria.deliver_report_date.$error,
                      }">
                    </b-form-input>
                    <div v-if="submitted && !$v.auditoria.deliver_report_date.required" class="invalid-feedback">
                      Este campo es requerido.
                    </div>
                  </b-form-group>
                </div>

                <div class="form-group text-right m-b-0">
                  <button type="submit" :disabled="submitted" class="btn btn-primary mx-1">
                    Guardar
                  </button>
                  <button type="reset" class="btn btn-secondary mx-1" @click="goBack">
                    Cancelar
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>

        <div v-else class="col-xl-12 text-center">
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>
        <!-- end card -->
      </div>
    </div>
    <!--- end row -->
  </Layout>
</template>

<style scoped>
.background-modal {
  background-color: transparent !important;
  border: none;
}
</style>
